import React from 'react';
import GoogleMap from 'google-map-react';

const Map = ({ children, ...rest }) => (
    <GoogleMap
        className="map"
        bootstrapURLKeys={{ key: 'AIzaSyD9hmyMtGQU1RnXKUgJK1LZQNXsH5mS6xE' }}
        defaultCenter={rest.defaultCenter || {
            lat: 50.9384491,
            lng: 4.1177652
        }}
        defaultZoom={rest.defaultZoom || 11}
        options={() => ({
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        })}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={rest.onGoogleApiLoaded}
        onChange={rest.onChange}
    >
        {children}
    </GoogleMap>
);

export { Map };
